var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39334 9.40802C6.39334 7.74268 7.74268 6.39335 9.40801 6.39202H10.78C11.576 6.39202 12.3387 6.07602 12.904 5.51602L13.8627 4.55602C15.0373 3.37468 16.9467 3.36935 18.128 4.54402L18.1293 4.54535L18.1413 4.55602L19.1013 5.51602C19.6667 6.07735 20.4293 6.39202 21.2253 6.39202H22.596C24.2613 6.39202 25.612 7.74135 25.612 9.40802V10.7773C25.612 11.5733 25.9267 12.3373 26.488 12.9027L27.448 13.8627C28.6293 15.0373 28.636 16.9467 27.4613 18.128L27.46 18.1293L27.448 18.1413L26.488 19.1013C25.9267 19.6653 25.612 20.428 25.612 21.224V22.596C25.612 24.2613 24.2627 25.6107 22.5973 25.6107H21.2227C20.4267 25.6107 19.6627 25.9267 19.0987 26.488L18.1387 27.4467C16.9653 28.628 15.0573 28.6347 13.876 27.4627C13.8747 27.4613 13.8733 27.46 13.872 27.4587L13.86 27.4467L12.9013 26.488C12.3373 25.9267 11.5733 25.612 10.7773 25.6107H9.40801C7.74268 25.6107 6.39334 24.2613 6.39334 22.596V21.2213C6.39334 20.4253 6.07734 19.6627 5.51601 19.0987L4.55734 18.1387C3.37601 16.9653 3.36934 15.0573 4.54268 13.876C4.54268 13.8747 4.54401 13.8733 4.54534 13.872L4.55734 13.86L5.51601 12.9C6.07734 12.3347 6.39334 11.572 6.39334 10.7747V9.40802Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 16.0002L14.667 18.6668L20.0003 13.3335",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.2d90ef885a1b33544ca60ed7c7791ccd.svg";
export { ForwardRef as ReactComponent };